import React from "react";

const ButtonIconLink = (props) => {
    const {history, to, disabled, iconClass, titulo = '' } = props;

    const clickHanlder = () => {
        history.push(to);
    }

    const resultClass = disabled ? "text-xs bg-blue-700 opacity-50 text-white font-bold py-2 px-3 rounded m-1" :
                                         "text-xs bg-blue-700 hover:bg-blue-600 text-white font-bold py-2 px-3 rounded m-1 focus:outline-none";
    return (
        <button className={resultClass}
                onClick={clickHanlder} disabled={disabled}>
            <i className={iconClass} /> {titulo}
        </button>
    );
}

export default ButtonIconLink;
